import { SpeakableScriptPart, SpeakableScriptPartType } from '../../main/types/asset/script.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { getLettersUtil } from '../../main/utils/asset/letters.util.ts';

export const mapPartToSpeakableScriptPart = (part: string): SpeakableScriptPart | null => {
  const letter = getLettersUtil().getLetter(part);
  if (letter?.file) {
    return { letter: part, type: SpeakableScriptPartType.Letter };
  }

  const pronunciation = getLessonsUtil().getPronunciation(part);
  if (!pronunciation) {
    return null;
  }

  if (!pronunciation.endsWith('.')) {
    return { text: `${pronunciation}.`, type: SpeakableScriptPartType.Text };
  }

  return { text: pronunciation, type: SpeakableScriptPartType.Text };
};
